// Snaps a size to a whole number of grid cells: n cells spanning the gaps
// between them = n*step + (n-1)*gap, at least one cell. gap=0 degrades to
// multiples of step. Returns the value unchanged for a non-positive step.
export const snapSizeToGrid = (
  value: number,
  step: number,
  gap = 0
): number => {
  if (!step || step <= 0) {
    return value;
  }

  const normalizedGap = Math.max(0, gap);
  const period = step + normalizedGap;
  const cellCount = Math.max(1, Math.round((value + normalizedGap) / period));

  return cellCount * period - normalizedGap;
};
